import React from "react";
import { CurriculumCalendar } from "./CurriculumCalendar";

function App() {
  return (
    <div className="App">
      <CurriculumCalendar />
    </div>
  );
}

export default App;
